module.exports = __webpack_public_path__ + "img/documentbussines.f52e0c86.png";